import React from 'react';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import AggregationBuilder from 'src/components/BeaconV2Components/utils/AggregationBuilder';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useComparisonTimePeriodShortDisplayName, useMainTimePeriodShortDisplayName } from 'src/utils/Hooks';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';

function buildAggregationFields(aggBuilder: AggregationBuilder): AggregationBuilder {
  return aggBuilder.clearConditionRangeFilters().addConditionRangeFilter('totalClicks', 1);
}

/**
 * Keywords with Traffic Spline Chart
 */
export default function KeywordsWithTrafficSplineChart() {
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();

  return (
    <BeaconComparableSplineChart
      indexName="traffic"
      fieldName="searchTerm"
      title={shouldShowBeaconProTopics() ? 'Keyword Count with Total Traffic' : 'Keywords with Traffic'}
      primaryAggregationBuilder={buildAggregationFields}
      secondaryAggregationBuilder={buildAggregationFields}
      beaconChartWithLegendOverride={
        shouldShowBeaconProTopics()
          ? (props) => ({
              ...props,
              includeSummaryInfo: false,
              subtitle: (
                <BeaconSubtitleContainer>
                  <Text variant="body1">
                    {`The chart displays the unique number of keywords that generated total traffic for `}
                    {entityPhrase} {taxonomyText}
                    {` during the`} {mainTimePeriodShortDisplayName} period compared to the{' '}
                    {comparisonTimePeriodShortDisplayName}.
                    <SubtitleFilters />
                  </Text>
                </BeaconSubtitleContainer>
              )
            })
          : undefined
      }
    />
  );
}
